import { Button, Table } from '@innovationdepartment/proxima-ui';
import type { BrandListProps } from 'types/brandList';
import ButtonGroup from 'ui/ButtonGroup';
import BrandListResultsWrapper from './BrandList.ResultsWrapper';

const BrandListBrands = <Row,>(props: BrandListProps<Row>) => {
  const { brandTableRef: ref, brands, config, onNext, onPrevious } = props;

  const content = <Table data={brands} tableWrapperRef={ref} config={config} />;

  return (
    <BrandListResultsWrapper>
      {content}
      <ButtonGroup>
        {!!onPrevious && <Button label="Previous" onClick={onPrevious} />}
        {!!onNext && <Button label="Next" onClick={onNext} />}
      </ButtonGroup>
    </BrandListResultsWrapper>
  );
};

export default BrandListBrands;
